var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6373 1.93917L12.6372 1.93899C12.2416 1.26877 11.6436 0.85 10.997 0.85C10.3528 0.85 9.75354 1.24412 9.35617 1.94017C9.356 1.94047 9.35582 1.94077 9.35565 1.94107L1.20111 15.8006L1.2011 15.8006L1.2001 15.8023C0.807988 16.4897 0.718759 17.169 1.06792 17.7408C1.393 18.3098 2.03213 18.5871 2.81926 18.5871H19.1748C19.9666 18.5871 20.6026 18.2849 20.9259 17.7411L20.9274 17.7387C21.2499 17.1719 21.1897 16.473 20.7927 15.8003L12.6373 1.93917ZM2.10553 17.1498L2.1056 17.1498L2.10304 17.1455C2.01345 16.9971 2.02435 16.7323 2.2349 16.3978L2.23495 16.3978L2.23718 16.3941L10.3916 2.55679C10.4961 2.39102 10.6073 2.26246 10.7152 2.17679C10.8243 2.09008 10.92 2.05487 10.9968 2.05487C11.1834 2.05487 11.4098 2.19654 11.5978 2.54925L11.5977 2.54932L11.6009 2.55486L19.7565 16.3941L19.7564 16.3941L19.7588 16.3978C19.9658 16.7268 19.9839 16.9964 19.9099 17.1503C19.8174 17.2973 19.5803 17.4039 19.1747 17.4039L2.81912 17.4041C2.62272 17.4041 2.45907 17.3732 2.33605 17.3238C2.21166 17.2739 2.13907 17.2097 2.10553 17.1498Z",
    fill: "#DA2E30",
    stroke: "#DA2E30",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.5V11.5",
    stroke: "#DA2E30",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 14,
    r: 1,
    fill: "#DA2E30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.5774fbf5b5b71a21d9e5dbb38eac0203.svg";
export { ForwardRef as ReactComponent };